module.exports = __webpack_public_path__ + "static/media/fStar.e66685e7.svg";